import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <h1 className="text-4xl lg:text-5xl font-bold text-vokaris-teal mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-vokaris-teal/70 mb-6">
            <strong>Last updated:</strong> December 1, 2025
          </p>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              1. Introduction
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              Vokaris Corporation ("we," "us," or "our") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              use our platform and services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              2. Information We Collect
            </h2>
            <h3 className="text-xl font-semibold text-vokaris-teal mb-3">
              2.1 Information You Provide
            </h3>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>
                Account registration information (name, email, company details)
              </li>
              <li>Billing and payment information</li>
              <li>User-generated content and data uploaded to our services</li>
              <li>Communications with our support team</li>
            </ul>

            <h3 className="text-xl font-semibold text-vokaris-teal mb-3">
              2.2 Automatically Collected Information
            </h3>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>Device and browser information</li>
              <li>IP addresses and location data</li>
              <li>Usage data and analytics</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              3. How We Use Your Information
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              We use your information to:
            </p>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send billing notifications</li>
              <li>Respond to customer support requests</li>
              <li>
                Send product updates and marketing communications (with your
                consent)
              </li>
              <li>Monitor and analyze usage patterns and trends</li>
              <li>Detect, prevent, and address security issues</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              4. Data Security
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              We implement industry-standard security measures to protect your
              data:
            </p>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>Encryption at rest and in transit (TLS/SSL)</li>
              <li>Regular security audits and penetration testing</li>
              <li>Access controls and authentication mechanisms</li>
              <li>Data backup and disaster recovery procedures</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              5. Data Sharing and Disclosure
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              We do not sell your personal information. We may share your data
              with:
            </p>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>
                Service providers and business partners who assist in our
                operations
              </li>
              <li>
                Law enforcement when required by law or to protect our rights
              </li>
              <li>Third parties with your explicit consent</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              6. Your Rights
            </h2>
            <p className="text-vokaris-teal/70 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-vokaris-teal/70 mb-4 space-y-2">
              <li>Access, update, or delete your personal information</li>
              <li>Object to or restrict processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
              <li>Lodge a complaint with a supervisory authority</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              7. Data Retention
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              We retain your information for as long as necessary to provide our
              services and comply with legal obligations. You may request
              deletion of your data at any time, subject to legal retention
              requirements.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              8. International Data Transfers
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              Your data may be transferred to and processed in countries other
              than your country of residence. We ensure appropriate safeguards
              are in place to protect your data in compliance with applicable
              laws.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              9. Children's Privacy
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              Our services are not intended for individuals under the age of 18.
              We do not knowingly collect personal information from children.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              10. Changes to This Policy
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              We may update this Privacy Policy from time to time. We will
              notify you of any material changes by posting the new policy on
              this page and updating the "Last updated" date.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-vokaris-teal mb-4">
              11. Contact Us
            </h2>
            <p className="text-vokaris-teal/70 mb-4">
              If you have questions about this Privacy Policy, please contact us
              at:
            </p>
            <p className="text-vokaris-teal/70">
              Email:{" "}
              <a
                href="mailto:hello@vokaris.io"
                className="text-vokaris-green font-semibold hover:underline"
              >
                hello@vokaris.io
              </a>
              <br />
              Address: Vokaris Corporation, 1309 Coffeen Avenue STE 1200,
              Sheridan, WY 82801, USA
            </p>
          </section>
        </div>

        {/* Back Link */}
        <div className="mt-12">
          <Link
            to="/"
            className="text-vokaris-green font-semibold hover:text-vokaris-teal transition"
          >
            ← Back to Home
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
}
